import React, { JSX } from 'react'
import { Link } from 'react-router-dom';
import { getRelativeTime } from '../../../../../api/callApi';
import { fileUrl } from '../../../../../api/config';
import { UiBlog } from '../../../../../api/types';

interface BlogCardProps {
    article: UiBlog;
}

export default function BlogCard({ article }: BlogCardProps): JSX.Element {
    return (
        <div className="col-md-6 col-lg-6 mb-2">
            <div
                className="
                   project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4
                "
                style={{ cursor: "pointer" }}
            >

                {/* IMAGE */}
                <div className="position-relative">
                    <img
                        src={`${fileUrl}/images/${article.icone}`}
                        alt={article.titre}
                        className="img-fluid w-100"
                        style={{
                            height: "220px",
                            objectFit: "cover"
                        }}
                    />

                    {/* BADGE CATÉGORIE */}
                    {article.category_blog?.titre && (
                        <span
                            className="
                                badge bg-primary 
                                position-absolute top-0 start-0 
                                m-1
                                rounded-pill shadow-sm
                            "
                        >
                            {article.category_blog.titre}
                        </span>
                    )}
                </div>

                {/* BODY */}
                <div className="card-body">

                    {/* DATE */}
                    <div className="mb-2 text-muted small d-flex align-items-center">
                        <i className="fas fa-calendar-alt me-2 text-primary"></i>
                        Publié {getRelativeTime(article.createdAt ?? "")}
                    </div>

                    {/* TITRE */}
                    <h3 className="h5 fw-bold text-dark mb-2 text-truncate-2">
                        <Link to={`/blog/${article.slug}`} style={{ textDecoration:"none" }}> {article.titre}</Link>
                    </h3>

                    {/* SOUS TITRE */}
                    <p className="text-muted mb-3 text-truncate-3">
                        {article.sousTitre}
                    </p>

                    {/* TAGS */}
                    <div className="mb-2">
                        {article.tug
                            ?.split(",")
                            .map((tag) => tag.trim())
                            .filter((tag) => tag.length > 0)
                            .map((tag, index) => (
                                <span
                                    key={index}
                                    className="badge rounded-pill bg-light text-dark border me-1 mb-1"
                                >
                                    #{tag}
                                </span>
                            ))}
                    </div>
                </div>

               

            </div>
        </div>
    );
}
